<template>
	<div>
		<select
			class="form-select"
			id="form-select-sort"
			v-model="model"
			@change="updateSort()"
		>
			<option
				v-for="option in options"
				:value="option.adProperty + ',' + option.sortOrder"
				:key="option"
				:selected="option.adProperty === model"
			>
				{{ option.title }}
			</option>
		</select>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormSelectSort',
	data() {
		return {
			selected: '',
			model: 'images,-1',
			options: [
				{
					title: 'Standardsortierung',
					adProperty: 'images',
					sortOrder: -1,
				},
				{
					title: 'Finanzierungsrate, absteigend',
					adProperty: 'financing.monthlyInstallment',
					sortOrder: -1,
				},
				{
					title: 'Finanzierungsrate, aufsteigend',
					adProperty: 'financing.monthlyInstallment',
					sortOrder: 1,
				},
				{
					title: 'Leasingrate, absteigend',
					adProperty: 'leasingGrossRate',
					sortOrder: -1,
				},
				{
					title: 'Leasingrate, aufsteigend',
					adProperty: 'leasingGrossRate',
					sortOrder: 1,
				},
				{
					title: 'Kaufpreis, absteigend',
					adProperty: 'price.consumerPriceGross',
					sortOrder: -1,
				},
				{
					title: 'Kaufpreis, aufsteigend',
					adProperty: 'price.consumerPriceGross',
					sortOrder: 1,
				},
				{
					title: 'Erstzulassung, absteigend',
					adProperty: 'firstRegistration',
					sortOrder: -1,
				},
				{
					title: 'Erstzulassung, aufsteigend',
					adProperty: 'firstRegistration',
					sortOrder: 1,
				},
				{
					title: 'Kilometerstand, absteigend',
					adProperty: 'mileage',
					sortOrder: -1,
				},
				{
					title: 'Kilometerstand, aufsteigend',
					adProperty: 'mileage',
					sortOrder: 1,
				},
				{
					title: 'Erstellt, absteigend',
					adProperty: 'creationDate',
					sortOrder: -1,
				},
				{
					title: 'Erstellt, aufsteigend',
					adProperty: 'creationDate',
					sortOrder: 1,
				},
			],
		}
	},
	props: {
		label: {
			type: String,
			default: '',
		},
	},
	methods: {
		updateSort() {
			let sortItem = this.model.split(',')
			const state = store.state

			/*if(state.price.filter === 'leasing' && sortItem[0] === 'financing.monthlyInstallment'){
				this.options[3].adProperty = 'leasingGrossRate'
				this.options[4].adProperty = 'leasingGrossRate'
			}else if(state.price.filter === 'finance' && sortItem[0] !== 'leasingGrossRate'){
				this.options[3].adProperty = 'financing.monthlyInstallment'
				this.options[4].adProperty = 'financing.monthlyInstallment'
			}*/

			if (sortItem[0] === 'financing.monthlyInstallment') {
				store.commit('updatePrice', 'finance')
			}
			if (sortItem[0] === 'leasingGrossRate') {
				store.commit('updatePrice', 'leasing')
			}
			store.commit('updateSort', sortItem)
			this.$emit('updateList')
		},
	},
	created() {
		const state = store.state
		if (
			state.sortItems.adProperty !== 'images' ||
			state.sortItems.sortOrder !== -1
		) {
			this.model = state.sortItems.adProperty + ',' + state.sortItems.sortOrder
		}
	},
}
</script>
